import { DropdownMenu } from "radix-ui";
import { MoreHorizontal } from "lucide-react";
import { Link } from "react-router-dom";
import type { ToolAction } from "./types";
import styles from "./ToolPage.module.css";
export function RowActions({
  label,
  actions,
}: {
  label: string;
  actions: ToolAction[];
}) {
  if (!actions.length) return null;
  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger
        className={styles.menuTrigger}
        aria-label={`Actions for ${label}`}
      >
        <MoreHorizontal size={20} aria-hidden="true" />
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content
          align="end"
          sideOffset={4}
          className={styles.menu}
        >
          {actions.map((action) => (
            <DropdownMenu.Item
              asChild
              key={action.label}
              disabled={!!action.disabledReason || action.pending}
            >
              {action.href !== undefined ? (
                <Link
                  to={action.href}
                  title={action.disabledReason}
                  onClick={(event) => {
                    if (action.disabledReason) {
                      event.preventDefault();
                      event.stopPropagation();
                    }
                  }}
                >
                  {action.label}
                  {action.disabledReason && (
                    <small>{action.disabledReason}</small>
                  )}
                </Link>
              ) : (
                <button
                  type="button"
                  disabled={!!action.disabledReason || action.pending}
                  onClick={() => {
                    if (!action.disabledReason && !action.pending)
                      action.onSelect();
                  }}
                  title={action.disabledReason}
                >
                  {action.pending ? "Please wait…" : action.label}
                  {action.disabledReason && (
                    <small>{action.disabledReason}</small>
                  )}
                </button>
              )}
            </DropdownMenu.Item>
          ))}
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}
